export const formatSortCode = (sortCode) => {
  if (sortCode.toString().length !== 6) return sortCode;
  const parts = sortCode.toString().match(/\d{2}/g);
  return `${parts[0]}-${parts[1]}-${parts[2]}`;
};

export const formatMobile = (mobileNumber) => {
  const mobileNumberStr = mobileNumber.toString();
  if (mobileNumberStr.length < 11) return mobileNumberStr;
  return `${mobileNumberStr.substr(0, 5)} ${mobileNumberStr.substr(5, 3)} ${mobileNumberStr.substr(
    8
  )}`;
};
